const TextArea = ({ className = "", compact = false, ...props }) => {
  return (
    <textarea
      className={`photon-field ${className} bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark block w-full ${compact ? "px-2.5 py-1.5 rounded-md" : "p-[10px] rounded-[10px]"} text-[13px] text-ink-ink dark:text-ink-white placeholder-ink-copy-hover outline-none border-[0.5px] border-edge-hex-d8d8d8 dark:border-edge-hex-aaaaaa50 placeholder:italic disabled:opacity-50 disabled:cursor-not-allowed`}
      {...props}
    ></textarea>
  );
};

export const TextAreaWithCharacterLimit = ({
  value,
  onChange,
  className = "",
  maxLength,
  resizable = false,
  minHeight = "75px",
  ...props
}) => {
  const handleChange = (e) => {
    if (e.target.value.length <= maxLength) {
      onChange(e);
    }
  };

  const wrapperClasses = resizable
    ? `p-[10px] min-h-[${minHeight}] border-[0.5px] border-edge-hex-aaaaaa dark:border-edge-hex-aaaaaa80 bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark placeholder-ink-copy-hover placeholder:italic rounded-[10px] ${className}`
    : `p-[10px] h-[${minHeight}] border-[0.5px] border-edge-hex-aaaaaa dark:border-edge-hex-aaaaaa80 bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark placeholder-ink-copy-hover placeholder:italic rounded-[10px] ${className}`;

  const textAreaClasses = resizable
    ? "block w-full h-full resize-y border-none !p-0 rounded-none min-h-[60px]"
    : "block w-full h-full resize-none border-none !p-0 rounded-none";

  return (
    <div className={`photon-field-frame ${wrapperClasses}`}>
      <TextArea
        {...props}
        className={textAreaClasses}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
      />
      {/* <div className="text-right text-[#9FABCA] text-[10px] italic">
        {maxLength - value.length} character left
      </div> */}
    </div>
  );
};

export default TextArea;
